import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import React from 'react';
import Modals from '../../../../modal';
import FORM_MODALS from '../components/Dialogs';
import formActionsReducer from '../logic/formActionsReducer';
import formDataReducer from '../logic/formDataReducer';
import formLoader from '../logic/formLoader';
/**
 * @param {Array<Function>} reducers
 */

var createReducers = function createReducers(reducers) {
  return function (state, action) {
    var result = state;
    reducers.forEach(function (reducer) {
      result = reducer(result, action);
    });
    return result;
  };
};

export var FormActionsContext = React.createContext();
export var FormContext = React.createContext();
export var FormContextProvider = function FormContextProvider(_ref) {
  var children = _ref.children,
      _ref$reducers = _ref.reducers,
      reducers = _ref$reducers === void 0 ? [] : _ref$reducers;
  var reducerFunction = createReducers([formDataReducer].concat(_toConsumableArray(reducers)));
  var reducer = React.useReducer(reducerFunction, null, formLoader);
  React.useEffect(function () {
    Modals.register(FORM_MODALS);
  }, []);
  return React.createElement(FormContext.Provider, {
    value: reducer
  }, children);
};
export var FormActionsContextProvider = function FormActionsContextProvider(_ref2) {
  var children = _ref2.children,
      _ref2$reducers = _ref2.reducers,
      reducers = _ref2$reducers === void 0 ? [] : _ref2$reducers;
  var reducerFunction = createReducers([formActionsReducer].concat(_toConsumableArray(reducers)));
  var reducer = React.useReducer(reducerFunction, null, function () {
    return {};
  });
  return React.createElement(FormActionsContext.Provider, {
    value: reducer
  }, children);
};